// 判断是否是移动端
export const isMobile = () => {
  const ua = window.navigator.userAgent.toLowerCase();
  return /mobile/i.test(ua);
};
